// web/src/api/languages.ts
//
// Typed client for GET /api/v1/languages — the operator-curated list of
// languages the collector currently supports (and that the API will
// accept on PATCH /me.preferred_language). The endpoint is unauthenticated
// so it can power the cold-boot resolution path + the signed-out auth
// pages without a 401 round-trip.
import { apiFetch } from "./client";

export type LanguageEntry = {
  code: string;
  display_name: string;
  native_name: string;
  rtl: boolean;
};

export type LanguagesResponse = {
  languages: LanguageEntry[];
};

export const languagesApi = {
  list: () => apiFetch<LanguagesResponse>("/api/v1/languages"),
};
